import React from "react"

import * as MuiIcons from "@mui/icons-material"

// import { ReactSVG } from "react-svg"

export default ({ iconName, style, ...props }) => {
  const Icon = MuiIcons[iconName]
  if (Icon) {
    return <Icon {...props} sx={style} />
  } else {
    // if (iconName === "path") {
    //   return <ReactSVG
    //     src={`/static/images/path.svg`}
    //     style={style}
    //     wrapper="span"
    //   />
    // } else {
    return iconName
    // }
  }
}